module.exports = __webpack_public_path__ + "static/media/it-specialist-java.fa25a361.png";